// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseRadioButton__root___3Pl4c","label":"EnterpriseRadioButton__label___3RizG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseRadioButton/EnterpriseRadioButton.scss
// module id = 1023
// module chunks = 0